<template>
  <div>
    <div class="mt-4 flex flex-row justify-between">
      <span class="text-sm uppercase text-gray-500 tracking-wider leading-4">
        {{ title }}
      </span>
      <span
        class="text-xs uppercase text-blue-500 cursor-pointer tracking-wider
        leading-4"
        @click="uploadFile"
        v-tooltip="'Upload a file'"
      >
        Upload
      </span>
    </div>

    <section
      class="border border-gray-300 overflow-auto p-2 pl-3 rounded-md flex
      flex-wrap justify-start"
      style="max-height:200px"
    >
      <div
        class="w-24 m-2 rounded-md"
        v-for="(img, idx) in images"
        v-if="imagesPresent && imageMode"
      >
        <div
          class="p-1 rounded-md element"
          :class="{ selected: selectedUrls.includes(img.url) }"
        >
          <img
            :key="idx"
            class="object-cover h-24 w-24 rounded-md border-3 border-gray-200"
            :src="img.url"
            @click="selectUrl(img.url)"
          />
        </div>
      </div>

      <div
        class="w-24 m-2 rounded-md"
        v-for="(vid, idx) in videos"
        v-if="videosPresent && videoMode"
      >
        <div
          class="p-1 rounded-md element"
          :class="{ selected: element.url == vid.url }"
        >
          <video
            :key="idx"
            class="object-cover h-32 w-32 rounded-md border-3 border-gray-200"
            :src="vid.url"
            @click="selectedFile(vid.url)"
            controls
          ></video>
        </div>
      </div>
       <div
        class="w-24 m-2 rounded-md"
        v-for="(img, idx) in images"
        v-if="imagesPresent && titleMode"
      >
        <div
          class="p-1 rounded-md element"
          :class="{ selected: element.url == img.url }"
        >
          <img
            :key="idx"
             class="object-cover h-24 w-24 rounded-md border-3 border-gray-200"
            :src="img.url"
            @click="selectedFile(img.url)"
          />
        </div>
      </div>
      <div v-if="!imagesPresent && (imageMode || titleMode) || !videosPresent && videoMode  || !audiosPresent && audioMode " class="p-4">
        <h1 class="tracking-wider uppercase text-blue-500 text-md">
          {{ notAvailableMessage }}
        </h1>
      </div>
      <div
      class="object-cover h-26 w-26 rounded-md border-3 border-gray-200"
      v-for="(aud, idx) in audio"
      v-if="audiosPresent && audioMode"
    >
      <div
        class="p-1 rounded-md element"
        :class="{ selectedAudio: element.url == aud.url }"
      >
        <audio loop mute controls

          :key="idx"
          class="object-cover h-16 w-30 rounded-md border-3 border-gray-200"
          :src="aud.url"
          @click="selectedFile(aud.url)"
        ></audio>

      </div>
      </div>
    </section>
  </div>
</template>

<script>
// import Component from "../component_location"
import { openFilePicker, EventBus } from "@/utils.js";

export default {
  components: {},

  props: {
    mode: { type: String, default: "images" },
    title: { type: String, default: "Select Image" },
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {};
  },

  watch: {
    element: {
      deep: true,
      handler() {
      
      },
    },
  },

  methods: {
    uploadFile() {
      const client = openFilePicker();
      var acceptable;
      if (this.imageMode || this.titleMode) {
        acceptable = ["image/*"];
      } else if (this.videoMode) {
        acceptable = ["video/mp4"]; // only allow MP4 for cross-browser compatibility.
      }  else if (this.audioMode) {
        acceptable = ["audio/*"]; 
      }
      var options = {
        accept: acceptable,
        onUploadDone: this.filesUploaded,
        onCancel: (e) => {
          this.uploading = false;
        },
        maxFiles: 5,
        transformations: { crop: false, circle: false, rotate: false },
      };
      client.picker(options).open();
    },

    filesUploaded(fileInfo) {
      var filesUploaded = fileInfo.filesUploaded;
      // Remove the originalFile embedded document business — redundant information.
      filesUploaded.forEach((file) => {
        delete file.originalFile;
      });

      if (this.imageMode || this.titleMode) {
        var details = {
          narrativeId: this.element.narrativeId,
          files: filesUploaded,
        };
        this.$store.dispatch("datasets/uploadImages", details);
      } else if (this.videoMode) {
        var details = {
          narrativeId: this.element.narrativeId,
          files: filesUploaded,
        };
        this.$store.dispatch("datasets/uploadVideos", details);
      }
      else if (this.audioMode) {
        var details = {
          narrativeId: this.element.narrativeId,
          files: filesUploaded,
        };
        this.$store.dispatch("datasets/uploadAudio", details);
      }
    },

    getImages() {
      this.$store.dispatch("narratives/getImages", this.element.narrativeId);
    },

    getVideos() {
      this.$store.dispatch("narratives/getVideos", this.element.narrativeId);
    },

    getAudio() {
      this.$store.dispatch("narratives/getAudio", this.element.narrativeId);
    },

    selectUrl(url) {
      let { urls = [] } = this.element
      if(urls.includes(url)) {
        urls = urls.filter(e => e != url)
      } else if(urls.length < 4) {
        urls = urls.concat([url])
      }
      this.$store.dispatch("narratives/updateElementItem", {...this.element, urls});
    },
     selectedFile(url) {
      this.element.url = url;
      if (this.element.type == "VIDEO") {
        this.element.videoControls = true;
      }
    },

  },

  computed: {
    notAvailableMessage() {
      if (this.imageMode) {
        return "No images available.";
      } else if (this.videoMode) {
        return "No videos available.";
      } else if (this.audioMode) {
          return "No audio available.";
      } else if (this.titleMode) {
          return "No logos available.";
      }
    },

    images() {
      return this.$store.state.narratives.current.images;
    },

    videos() {
      return this.$store.state.narratives.current.videos;
    },

    audio() {
      return this.$store.state.narratives.current.audio;
    },



    itemsPresent() {
      return this.imagesPresent || this.videosPresent || this.audiosPresent;
    },

    imagesPresent() {
      return this.images.length > 0;
    },

    videosPresent() {
      return this.videos.length > 0;
    },

    audiosPresent() {
      return this.audio.length > 0;
    },

    imageMode() {
      return this.mode == "images";
    },

    titleMode() {
      return this.mode == "logos";
    },

    videoMode() {
      return this.mode == "videos";
    },

    audioMode() {
      return this.mode == "audio";
    },
    
    selectedUrls() {
      return this.element.urls || []
    }

  },

  mounted() {
    

    if (this.imageMode || this.titleMode) {
      console.log(this.element.narrativeId);
      this.getImages();
      EventBus.$on("files-uploaded", this.getImages);
    } else if (this.videoMode) {
      this.getVideos();
      EventBus.$on("files-uploaded", this.getVideos);
    }
     else if (this.audioMode) {
      this.getAudio();
      EventBus.$on("files-uploaded", this.getAudio); 
    }
  },
};
</script>

<style>
.selected {
  border: 3px solid #60a5fa !important;
  /* border: 3px solid black; */
}
audio:focus {
    outline: none;
}
.selectedAudio {
  border: 3px solid #60a5fa !important;
  /* border: 3px solid black; */
  
}
.element:hover {
     background-color:#989898	;
}
</style>